import { Button, Modal, Slider, Space } from "antd";
import ReactCrop, { centerCrop, makeAspectCrop, Crop, PixelCrop, convertToPixelCrop } from "react-image-crop";
import { canvasPreview } from "./canvasPreview";
import { useDebounceEffect } from "./useDebounceEffect";

import "react-image-crop/dist/ReactCrop.css";
import "./upload.scss";
import { useEffect, useRef, useState } from "react";
import { blobToBase64, convertBlobToBase64 } from "../../../tools/tools";
const UploadImages = ({ value, isOpen, SelectFile, isEdit }) => {
  const [imgSrc, setImgSrc] = useState("");
  const previewCanvasRef = useRef(null);
  const imgRef = useRef(null);
  const hiddenAnchorRef = useRef(null);
  const blobUrlRef = useRef("");
  const [crop, setCrop] = useState();
  const [completedCrop, setCompletedCrop] = useState();
  const [scale, setScale] = useState(1);
  const [rotate, setRotate] = useState(0);
  const [modalopen, setOpenModal] = useState(false);
  const [tempImageProcess, setTempImageProcess] = useState();
  const [modalEdit, setModalEdit] = useState(false);

  useEffect(() => {
    if (SelectFile) {
      onSelectFile(SelectFile);
    }
  }, [SelectFile]);

  useEffect(() => {
    if (isOpen) {
      setOpenModal(true);
    }
  }, [isOpen]);
  useEffect(() => {
    if (isEdit) {
      setModalEdit(true);
    }
  }, [isEdit]);

  function onSelectFile(file) {
    if (file?.size > 0) {
      setCrop(16 / 9); // Makes crop preview update between images.
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImgSrc(reader.result?.toString() || "");
      });
      reader.readAsDataURL(file);
    }
  }

  function onDownloadCropClick() {
    setOpenModal(false);

    if (!previewCanvasRef.current) {
      throw new Error("Crop canvas does not exist");
    }

    previewCanvasRef.current.toBlob(async (blob) => {
      if (!blob) {
        throw new Error("Failed to create blob");
      }
      if (blobUrlRef.current) {
        URL.revokeObjectURL(blobUrlRef.current);
      }
      blobUrlRef.current = URL.createObjectURL(blob);
      const base64Image = await convertBlobToBase64(blobUrlRef.current);
      setTempImageProcess(base64Image);
      value(base64Image);
    });
  }
  function onImageLoad(e) {
    const { width, height } = e.currentTarget;
    // completedCrop;
    setCompletedCrop({ unit: "px", width: width, height: height });
  }
  useDebounceEffect(
    async () => {
      if (completedCrop?.width && completedCrop?.height && imgRef.current && previewCanvasRef.current) {
        // We use canvasPreview as it's much faster than imgPreview.
        canvasPreview(imgRef.current, previewCanvasRef.current, completedCrop, scale, rotate);
      }
    },
    100,
    [completedCrop, scale, rotate, crop],
  );

  const handleClose = async () => {
    setOpenModal(!modalopen);
    if (modalEdit) {
      value(tempImageProcess);
    } else {
      value();
    }
  };
  return (
    <>
      <Modal
        open={modalopen}
        onCancel={handleClose}
        title="آپلود فایل"
        footer={
          <>
            <div className="handle-Upload-footer">
              <Button className="btn-normal btn-aptel" danger onClick={onDownloadCropClick}>
                تایید
              </Button>
            </div>
          </>
        }
      >
        <div className="handle-Upload">
          {!!imgSrc && (
            <ReactCrop
              crop={crop}
              onChange={(_, percentCrop) => setCrop(percentCrop)}
              onComplete={(c) => setCompletedCrop(c)}
              aspect={undefined}
              // minWidth={400}
              minHeight={200}
            >
              <img ref={imgRef} onLoad={onImageLoad} alt="Crop me" src={imgSrc} style={{ transform: `scale(${scale}) rotate(${rotate}deg)` }} />
            </ReactCrop>
          )}

          <>
            <div className="row-item">
              <div className="label">
                <span>بزرگنمایی :</span>
              </div>
              <div className="slider">
                <Slider min={1} max={100} defaultValue={1} step={1} reverse={true} onChange={(value) => setScale(value)} />
              </div>
            </div>
            <div className="row-item">
              <div className="label">
                <span>چرخش :</span>
              </div>
              <div className="slider">
                <Slider
                  min={0}
                  max={360}
                  defaultValue={0}
                  step={0.1}
                  reverse={true}
                  onChange={(value) => setRotate(Math.min(100, Math.max(-100, value)))}
                />
              </div>
            </div>

            <div>
              <canvas
                ref={previewCanvasRef}
                style={{
                  display: "none",
                }}
              />
            </div>
          </>
        </div>
      </Modal>
    </>
  );
};

export default UploadImages;

// function centerAspectCrop(
//   mediaWidth: number,
//   mediaHeight: number,
//   aspect: number
// ) {
//   return centerCrop(
//     makeAspectCrop(
//       {
//         unit: "%",
//         width: 90,
//       },
//       aspect,
//       mediaWidth,
//       mediaHeight
//     ),
//     mediaWidth,
//     mediaHeight
//   );
// }
